<script>
	import { api } from "./../libs/api.js";
	import { startGeolocating } from "./../libs/device.js";
	import { MapController } from "./../libs/map.js";

	import { Link } from 'svelte-routing';

	import BaseLayer from "./../components/BaseLayer.svelte";
	import Map from "./../components/Map.svelte";

	export let id;
	let fence_size = 0.1;
	let trail, fences, mapcontroller;
	// Default initial coordinates
	let user_lat = 38.265894, user_lon = 15.650923; 

	function getFencesCoordinates(fences) {
		let coordinates = fences.map(el => {
			return el.location.coordinates;
		})
		return coordinates;
	}

	async function track_data() {
		let trail_promise = api.get_trail(id);
		let fences_promise = api.get_fences(id);

		trail = await trail_promise;
		fences = await fences_promise;

		mapcontroller = new MapController(
			trail.data.track,
			getFencesCoordinates(fences.data),
			[user_lat, user_lon]);
	}

	startGeolocating(position => {
		if (position) {
			user_lat = position.coords.latitude;
			user_lon = position.coords.longitude;
		}
	});
</script>

<BaseLayer --bg-overlay="url(/assets/bg/mountains.svg)">
	{#await track_data() then data}
		<Map
			latitude={user_lat}
			longitude={user_lon}
			mapcontroller={mapcontroller}/>

		<div class="px-4 pt-10 pb-20">

			<h3 class="page-title">{trail.data.translations[0].name}</h3>

			<div class="relative pt-10">
				{#each fences.data as fence}
					<span style="left: {mapcontroller.get_progress_from(fence.location.coordinates[1], fence.location.coordinates[0])}%;"
						class="absolute block -translate-x-1 top-8 text-accent">&#9652;</span>
				{/each}
				<svg style="left: {mapcontroller.get_progress_from(user_lat, user_lon)}%;"
					class="w-8 h-8 -translate-x-4 top-4 absolute" viewBox='0 0 320 512'>
					<path d='M256 48C256 74.51 234.5 96 208 96C181.5 96 160 74.51 160 48C160 21.49 181.5 0 208 0C234.5 0 256 21.49 256 48zM126.5 199.3C125.6 199.7 124.6 200.1 123.7 200.5L112.7 205.4C97.41 212.2 85.42 224.6 79.22 240.1L77.71 243.9C71.15 260.3 52.53 268.3 36.12 261.7C19.71 255.1 11.73 236.5 18.29 220.1L19.8 216.3C32.19 185.4 56.18 160.5 86.66 146.9L97.66 142C118.5 132.8 140.1 128 163.7 128C208.3 128 248.5 154.8 265.6 195.9L280.1 232.7L302.3 243.4C318.1 251.3 324.5 270.5 316.6 286.3C308.7 302.1 289.5 308.5 273.7 300.6L247 287.3C236.7 282.1 228.6 273.4 224.2 262.8L214.6 239.8L195.3 305.3L244.8 359.4C250.2 365.3 254.1 372.4 256 380.2L279 472.2C283.3 489.4 272.9 506.8 255.8 511C238.6 515.3 221.2 504.9 216.1 487.8L194.9 399.6L124.3 322.5C109.5 306.4 103.1 283.9 109.6 262.8L126.5 199.3zM68.73 398L93.69 335.6C95.84 338.6 98.16 341.4 100.7 344.2L141.4 388.6L126.9 424.8C124.5 430.9 120.9 436.4 116.3 440.9L54.63 502.6C42.13 515.1 21.87 515.1 9.372 502.6C-3.124 490.1-3.124 469.9 9.372 457.4L68.73 398z'/>
				</svg>
				<progress class="progress progress-accent w-full" max="100"
					value="{mapcontroller.get_progress_from(user_lat, user_lon)}"></progress>
			</div>

			{#each fences.data as fence}
			{#if mapcontroller.get_distance(user_lat, user_lon, fence.location.coordinates[1], fence.location.coordinates[0]) < fence_size}
				<h3 class="page-title mt-4 mb-1">{fence.translations[0].name}</h3>
				<p class="rich-content">{@html fence.translations[0].description}</p>
			{/if}
			{/each}
		</div>
	{/await}
</BaseLayer>